class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    // Page-dimming scrim. It lives inside <cart-notification> (same stacking
    // context as the panel), so the body click-outside handler ignores it —
    // wire it directly. close() returns focus to the element product-form
    // stored, i.e. the Add to Cart button.
    this.scrim = this.querySelector('.cart-notification-scrim');
    if (this.scrim) this.scrim.addEventListener('click', this.close.bind(this));

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    // Second item added while already open: renderContents() has replaced the
    // product row and summary in place. Keep focus inside the panel; no re-animation.
    if (this.notification.classList.contains('active')) {
      this.notification.focus();
      return;
    }

    this.notification.classList.add('animate', 'active');
    if (this.scrim) this.scrim.classList.add('animate', 'active');

    // Trap focus once the slide-down completes. Fallback timer guarantees the
    // trap is applied even when no transition fires (e.g. prefers-reduced-motion).
    let focusApplied = false;
    const applyFocus = () => {
      if (focusApplied) return;
      focusApplied = true;
      this.notification.focus();
      trapFocus(this.notification);
    };
    this.notification.addEventListener('transitionend', applyFocus, { once: true });
    setTimeout(applyFocus, 350);

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    if (this.scrim) this.scrim.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-summary',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
